import {ReduxAction} from "../../models/common/ActionTypes";
import {ViewIdentifiable} from "../../models/common/ViewSettings";
import {MapByStr} from "../../models/common/Map";


export type GeneralFormActions = LockFormValuesAction
    | RemoveLockedFomValueAction
    | RemoveAllLockedFomValuesAction;

export interface LockFormValuesAction extends ViewIdentifiable, ReduxAction<typeof LOCK_FORM_VALUES> {
    /**
     * key should be the input identifier
     */
    lockedValues: MapByStr<any>
}

export interface RemoveAllLockedFomValuesAction extends ViewIdentifiable, ReduxAction<typeof REMOVE_ALL_LOCKED_FORM_VALUES> {}

export interface RemoveLockedFomValueAction extends ViewIdentifiable, ReduxAction<typeof REMOVE_LOCKED_FORM_VALUE> {
    keyToRemove: string
}

export const LOCK_FORM_VALUES = "LOCK_FORM_VALUES";
export const REMOVE_ALL_LOCKED_FORM_VALUES = "REMOVE_ALL_LOCKED_FORM_VALUES";
export const  REMOVE_LOCKED_FORM_VALUE = "REMOVE_LOCKED_FORM_VALUE";

export function lockFormValues( viewIdentifier: string, lockedValues: MapByStr<any> ): LockFormValuesAction {

    return {
        type: LOCK_FORM_VALUES,
        viewIdentifier,
        lockedValues
    };
}
export function removeAllLockedFormValues( viewIdentifier: string ): RemoveAllLockedFomValuesAction {
    return {
        type: REMOVE_ALL_LOCKED_FORM_VALUES,
        viewIdentifier
    };
}
export function removeLockedFormInputValue(viewIdentifier: string, keyToRemove: string ): RemoveLockedFomValueAction {
    return {
        type: REMOVE_LOCKED_FORM_VALUE,
        viewIdentifier,
        keyToRemove
    };
}


